export enum EContainerTypes {
  /* Отсутствие контейнера (баннер закрывается безвозвратно целиком) */
  NullContainer = 'nullContainer',
  /* Контейнер, где для добавления лейбла не нужно проходить профилирование */
  AddLabelWithoutProfiling = 'addLabelWithoutProfiling',
  /* С объектом пока нельзя провести онлайн-сделку */
  FormFailed = 'formFailed',
  /* 1 - Ваш объект находится в залоге? */
  IsMorgageQuestion = 'isMorgageQuestion',
  /* 2- Обременение будет снято при продаже вашего объекта? */
  EncumbranceWillBeRemoved = 'encumbranceWillBeRemoved',
  /* 3 - Все собственники граждане РФ? */
  OwnerCitizenshipQuestion = 'ownerCitizenshipQuestion',
  /* 4 - Материнский капитал использовался при покупке? */
  MaternityCapitalQuestion = 'maternityCapitalQuestion',
  /* 4 - Финальный экран когда значок добавлен */
  LabelAdded = 'labelAdded',
  /* 4 - Финальный экран, когда значок убран */
  LabelRemoved = 'labelRemoved',
}

export interface IMainFormQuestion {
  containerType: EContainerTypes;
  answerYes: string;
  answerNo: string;
  question: string;
  questionNumber: number;
  totalQuestionsCount: number;
  stepYes: string;
  stepNo: string;
}

export interface IFormContainerProps {
  containerType: EContainerTypes;
}
